import React from 'react'

import PaginationInactiveDotIcon from './PaginationDotIcons/PaginationInactiveDotIcon'
import PaginationActiveDotIcon from './PaginationDotIcons/PaginationActiveDotIcon'

import { tutorialDataTestIds } from '../mocks/tutorial-mocks'

import { getWalkthroughStepLabel } from './tutorial-pagination.util'

import styles from './TutorialPagination.module.scss'

type TutorialPaginationProps = {
  size: number
  activeItemIndex: number
}

const TutorialPagination = ({
  size = 0,
  activeItemIndex = 0,
}: TutorialPaginationProps) => (
  <div
    className={styles.tutorialPagination}
    data-testid={tutorialDataTestIds.tutorialPagination}
  >
    {size > 0 && activeItemIndex >= 0 && activeItemIndex < size && (
      <span className="visually-hidden">
        {getWalkthroughStepLabel(activeItemIndex, size)}
      </span>
    )}
    {Array.from({ length: size }, (_, index) => {
      if (index === activeItemIndex) {
        return (
          <PaginationActiveDotIcon
            key={index}
            data-testid={tutorialDataTestIds.activeDot}
          />
        )
      }
      return (
        <PaginationInactiveDotIcon
          key={index}
          data-testid={tutorialDataTestIds.inactiveDot}
        />
      )
    })}
  </div>
)

export default TutorialPagination
